import $ from 'jquery'

import colors from '../../../../../lib/colors'
import * as timecode from '../../../../../lib/timecode'

export default function(o){

  var getMarker = function(left,type){
    if(type == 'archive'){
      var color = colors.white
    } else {
      var color = o.colors.red
    }

    var marker =
      $('<div>')
      .css({
        position: 'absolute',
        width: '1px',
        height: '34px',
        top: 0,
        opacity: 0.3,
        left: left,
        background: color,
        pointerEvents: 'none',
      })

    return marker
  }

  var lastRoll = null

  var set = function(roll){

    if(!roll && lastRoll){
      roll = lastRoll
    } else {
      lastRoll = roll
    }

    div.empty()

    if(!o.video){
      return
    }

    var length = o.video.duration

    var archiveMarkers = _.map(
      _.filter(o.data.archive.markers,{roll:roll}),
      function(marker){
        return timecode.toSeconds(marker.start)
      },
    )

    var antiArchiveMarkers = _.map(
      _.filter(o.data.antiArchive.markers,{roll:roll}),
      function(marker){
        return timecode.toSeconds(marker.start)
      },
    )

    // console.log("roll", roll, archiveMarkers.length, antiArchiveMarkers.length)

    _.each(archiveMarkers, function(marker){
      var left = Math.round(marker / length * 400 * 100) / 100
      div.append(getMarker(left,'archive'))
    })

    _.each(antiArchiveMarkers, function(marker){
      var left = Math.round(marker / length * 400 * 100) / 100
      div.append(getMarker(left,'anti-archive'))
    })

  }

  var reset = function(){
    div.empty()
  }

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      left: 0,
      right: 0,
      height: '34px',
      pointerEvents: 'none',
    })

  div.set = set
  div.reset = reset

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/player/timeline/markers/markers.js